import { render, staticRenderFns } from "./RosterTeamFooter.vue?vue&type=template&id=7960f9f2&scoped=true&"
import script from "./RosterTeamFooter.vue?vue&type=script&lang=js&"
export * from "./RosterTeamFooter.vue?vue&type=script&lang=js&"
import style0 from "./RosterTeamFooter.vue?vue&type=style&index=0&id=7960f9f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960f9f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/web apps/HMS_Web_App_Vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VChip,VTooltip})
